@import 'styles/mixins';
@import 'styles/blaze/mixins';
@import 'styles/variables';

.container {
  display: flex;
  align-items: center;
  gap: 4px;
  transition: min-width 150ms ease-in-out;

  .inputContainer {
    display: flex;
    padding: 8px;
    gap: 6px;
    align-items: center;
    align-self: stretch;
    border-radius: 6px;
    height: 40px;
    background-color: var(--light-100);

    svg {
      min-width: 24px;
    }
  }

  .input {
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 0;

    textarea {
      height: 24px;
    }
  }

  .textarea {
    @include md-sohne;
    padding: 0;
    height: 18px;
    width: 125px;

    &::placeholder {
      @include md-sohne;
      color: var(--dark-80);
    }
  }

  &.focused {
    min-width: 100%;
    flex: 1;

    .textarea {
      width: 100%;

      &::placeholder {
        color: var(--dark-60);
      }
    }

    .inputContainer {
      flex: 1;
      box-shadow: inset 0 0 0 2px var(--selected-fill);
    }
  }
}
